import dom from '../../../wrapper/DomWrapper';
import { LOCAL } from '../constants';

export default () => dom.document.location.href.indexOf(LOCAL) >= 0;
